import { render, staticRenderFns } from "./SearchClaim.vue?vue&type=template&id=0c5271f9&"
import script from "./SearchClaim.vue?vue&type=script&lang=js&"
export * from "./SearchClaim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports